import { FuelTypeEnum, FuelUnitEnum } from '../../models'
import {
  FuelAction,
  FuelState,
  SET_FUELS,
  SET_FUELS_LOADED,
  SET_FUEL_FILTER,
  SET_SELECTED_FUEL,
} from '../types'

const initialState: FuelState = {
  fuels: [],
  isFuelsLoaded: false,
  fuelFilter: {
    name: '',
    units: Object.values(FuelUnitEnum),
    types: Object.values(FuelTypeEnum),
  },
}

export const fuelReducer = (
  state = initialState,
  action: FuelAction
): FuelState => {
  switch (action.type) {
    case SET_FUELS:
      return {
        ...state,
        fuels: action.payload,
      }
    case SET_FUELS_LOADED:
      return {
        ...state,
        isFuelsLoaded: action.payload,
      }
    case SET_FUEL_FILTER:
      return {
        ...state,
        fuelFilter: action.payload,
      }
    case SET_SELECTED_FUEL:
      return {
        ...state,
        selectedFuel: action.payload,
      }
    default:
      return state
  }
}
